import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/annual-tax-report';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

type UpdateTaxYearData = Api.UpdateTaxYearRequest & {
  taxYearStart: number;
};

function useUpdateTaxYear() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: UpdateTaxYearData) =>
      (
        await api.put<ApiResponse<Api.UpdateTaxYearResponse>>(
          `/annual-tax-report/${data.taxYearStart}`,
          data,
        )
      ).data,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['tax-years'],
      });
    },
  });
}

export default function useTaxYears(params: {
  page: number;
  rowsPerPage: number;
  firmId?: string;
}) {
  const taxYears = useQuery({
    queryKey: ['tax-years', params],
    queryFn: async () =>
      (
        await api.get<ApiResponse<Api.GetTaxYearsResponse>>(
          '/annual-tax-report/tax-years',
          { params },
        )
      ).data.data,
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });

  return { taxYears, updateTaxYear: useUpdateTaxYear() };
}
